import cleanProfile from './dryRunColorCleanProfile.json';

// Canned synthetic colour bench profiles (PLAN P2-7). Every value is INVENTED — no real applicant
// record may be copied into an example — and every key is one of the colour family's 8 catalogue
// paths (`rules/seed-data/colorcoding/isc.baseline.json`'s `fields[]`), the same shape a case's
// `profile` is evaluated against. Each scenario is the FULL clean profile plus its own overrides,
// never a handful of fields on their own — an absent field is a `field_absent` skip, not a zero.
const withOverrides = (overrides: Record<string, unknown>): Record<string, unknown> => ({
  ...cleanProfile,
  ...overrides,
});

export interface DryRunColorSampleProfile {
  readonly id: string;
  readonly labelKey: string;
  readonly profile: Record<string, unknown>;
}

export const DRY_RUN_COLOR_SAMPLE_PROFILES: DryRunColorSampleProfile[] = [
  {
    id: 'baseline',
    labelKey: 'rules.dryRun.colorSample.baseline',
    profile: withOverrides({}),
  },
  {
    id: 'strongCandidate',
    labelKey: 'rules.dryRun.colorSample.strongCandidate',
    profile: withOverrides({
      embryosStatus: 'ready',
      referredFrom: 'referred',
      journeyReadiness: 'readyTo',
      isWorkingWithIVF: true,
      clinicName: 'Example Fertility Clinic',
    }),
  },
  {
    id: 'restrictedCountry',
    labelKey: 'rules.dryRun.colorSample.restrictedCountry',
    profile: withOverrides({ country: 'CN' }),
  },
];
